export default "__VITE_ASSET__02a582e1__"